import OutlineCheckIcon from 'components/Icons/OutlineCheckIcon'
import { BlueText } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/NotificationData/styles'
import { BlueButton } from 'pages/NotifyEventPatient/styles'
import React, { Dispatch, SetStateAction } from 'react'
import { ICreateNewNotificationResponse } from 'types/notification';
import { formatDateTime } from 'utils/dateUtils';


export interface INotificationSentSuccess{
  responseData: ICreateNewNotificationResponse
  setResponseData: Dispatch<SetStateAction<ICreateNewNotificationResponse>>
  makeNewNotificationFromZero: () => void
  reset:any

}
export default function NotificationSentSuccess({ responseData , setResponseData,makeNewNotificationFromZero,reset}: INotificationSentSuccess) {
  return (
    <div data-testid="notification-sent-success" className='flex flex-col items-center justify-center pb-12 pt-[65px] px-6'>
      <OutlineCheckIcon
        color={"#0ABB89"}
        height={"67"}
        width={"67"}
      />
      <BlueText className='md:text-3xl mt-2 text-center text-base'>Sua notificação foi enviada!</BlueText>
      <p className='text-darkGray mt-1 text-center md:text-base text-xs'>Obrigado por notificar! A partir de agora a equipe responsável acompanhará sua notificação. </p>
      <div className='mt-5 border border-[#EBEFF5] rounded-lg px-6 py-4 flex flex-col justify-center items-center w-[312px] md:w-[476px]'>
        <p className='text-darkGray font-semibold md:text-base text-sm'>Chave da Notificação</p>
        <p className='text-darkGray font-bold mt-2 tracking-widest md:text-[20px] text-base'>{responseData.number}</p>
        <div className='flex md:flex-row flex-col mt-2 md:gap-4 justify-center items-center md:w-[476px]' >
          <p className='text-darkGray md:text-base text-xs'>Data da abertura da notificação</p>
          <p className='text-darkGray font-semibold md:text-base text-sm'>{formatDateTime(new Date())}</p>
        </div>
      </div>
      <div className='mt-14 flex flex-col gap-4 justify-center'>
        <BlueButton
          type="button"
          onClick={() => {
            makeNewNotificationFromZero()
          }}
          className="sm:w-[392px] w-[251px]"
        >
          Abrir uma nova notificação
        </BlueButton>
     
        <p
          onClick={() => {
            makeNewNotificationFromZero()
          }}
          className="underline text-blueTheme text-sm cursor-pointer text-center">Sair</p>
      </div>
    </div>
  )
}

